import { FC, useState, ChangeEvent, useEffect } from 'react'
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs'

import { Layout } from '../../../containers'
import { Title, Text, Select, Button } from '../../../components/UI'
import { BudgetRequestForm, BudgetsRequested } from '../../../components/Dashboard'
import { useFamilyGroup, useBudgetsRequested, useInterventions, useForecasts, useTreatingsPhysicians } from '../../../hooks'
import config from '../../../../config'

const tabClass = 'react-tabs__tab react-tabs_col-2'

const BudgetRequestPage:FC = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const [familyFilterSelected, setFamilyFilterSelected] = useState<string>('')
  const familyFilter = useFamilyGroup('FILTER')
  const interventions = useInterventions()
  const forecasts = useForecasts()
  const treatingsPhysicians = useTreatingsPhysicians()
  const budgetsRequested = useBudgetsRequested()

  const urlParams = new URLSearchParams(window.location.search);
  const fromFamilyGroup = urlParams.get('from_family_group');

  const patientId = urlParams.get('patient_id');

  useEffect(() => {
    if(patientId) {
      onFamilyFilterChange(patientId)
    }
  }, [patientId])

  const onTabSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { target: { value } } = event
    setTabIndex(Number(value))
  }

  const onFamilyFilterChange = (patientId: string) => {
    setFamilyFilterSelected(patientId)
    budgetsRequested.getById(patientId)
  }

  return (
    <Layout menu titleMain={6}>
      <Title border>
      {fromFamilyGroup ? 'Mi grupo familiar / Solicitud de presupuestos' : 'Solicitud de presupuestos'}
      </Title>

      <Text size="14" className="lg:fz-16 mt-30">
        {fromFamilyGroup 
          ? 'En esta sección podrás solicitar presupuestos para tu grupo familiar a través de un formulario, así como ver el historial de presupuestos que hayas solicitado en el pasado.' 
          : 'En esta sección podrás solicitar presupuestos a través de un formulario, así como ver el historial de presupuestos que hayas solicitado en el pasado.'}
      </Text>

      {
        fromFamilyGroup === 'true' && (
          <Button 
            size="md" 
            color="primary" 
            className="mt-20 lg:mt-30" 
            component="link"
            to={`${config.ROUTES.DASHBOARD.FAMILYGROUP.HOME}`}
          >
            Volver a Mi Grupo Familiar
          </Button>
        )
      }

      <Select
        name="tabOptions"
        sizes="md"
        color="primary"
        value={tabIndex}
        fullWidth
        className="lg:d-none mt-50"
        onChange={onTabSelectChange}
      >
        <option value="0">Solicitud de presupuestos</option>
        <option value="1">Presupuestos solicitados</option>
      </Select>

      <Tabs
        selectedIndex={tabIndex}
        className="lg:mt-40"
        onSelect={index => setTabIndex(index)}
      >
        <TabList>
          <Tab className={tabClass}>Solicitud de presupuestos</Tab>
          <Tab className={tabClass}>Presupuestos solicitados</Tab>
        </TabList>

        <TabPanel>
          <BudgetRequestForm
            interventions={interventions.data}
            forecasts={forecasts.data}
            treatingsPhysicians={treatingsPhysicians.data}
            familyFilter={familyFilter}
            familyFilterSelected={familyFilterSelected}
            onFamilyFilterChange={onFamilyFilterChange}
            className="pt-20 pb-60 lg:px-60"
          />
        </TabPanel>
        <TabPanel>
          <BudgetsRequested
            data={budgetsRequested.data}
            familyFilter={familyFilter}
            familyFilterSelected={familyFilterSelected}
            onFamilyFilterChange={onFamilyFilterChange}
            className="py-20 lg:px-60"
          />
        </TabPanel>
      </Tabs>
    </Layout>
  )
}

export { BudgetRequestPage }